// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TrainingDropzoneController from "./training_dropzone_controller"
application.register("training-dropzone", TrainingDropzoneController)

import BasePhotoSelectorController from "./base_photo_selector_controller"
application.register("base-photo-selector", BasePhotoSelectorController)

import CreditPackageController from "./credit_package_controller"
application.register("credit-package", CreditPackageController)

import DownloadController from "./download_controller"
application.register("download", DownloadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterDropdownController from "./filter_dropdown_controller"
application.register("filter-dropdown", FilterDropdownController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import FaceDropzoneController from "./face_dropzone_controller"
application.register("face-dropzone", FaceDropzoneController)

import FacesDropdownController from "./faces_dropdown_controller"
application.register("faces-dropdown", FacesDropdownController)

import FaceFormController from "./face_form_controller"
application.register("face-form", FaceFormController)

import FlashesController from "./flashes_controller"
application.register("flashes", FlashesController)

import FormSubmissionController from "./form_submission_controller"
application.register("form-submission", FormSubmissionController)

import GifPlayerController from "./gif_player_controller"
application.register("gif-player", GifPlayerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HoverMenuController from "./hover_menu_controller"
application.register("hover-menu", HoverMenuController)

import ImageGenerationController from "./image_generation_controller"
application.register("image-generation", ImageGenerationController)

import LandingPageController from "./landing_page_controller"
application.register("landing-page", LandingPageController)

import MasonryController from "./masonry_controller"
application.register("masonry", MasonryController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import HamburgerMenuController from "./hamburger_menu_controller"
application.register("hamburger-menu", HamburgerMenuController)

import TypedJsController from "./typed_js_controller"
application.register("typed-js", TypedJsController)

import UpscaleOptionController from "./upscale_option_controller"
application.register("upscale-option", UpscaleOptionController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import MediaSelectorController from "./media_selector_controller"
application.register("media-selector", MediaSelectorController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import MaskEditorController from "./mask_editor_controller"
application.register("mask-editor", MaskEditorController)

import MultipleDropzoneController from "./multiple_dropzone_controller"
application.register("multiple-dropzone", MultipleDropzoneController)

import CostCalculatorController from "./cost_calculator_controller"
application.register("cost-calculator", CostCalculatorController)

import BatchDownloadController from "./batch_download_controller"
application.register("batch-download", BatchDownloadController)

import UploadOverlayController from "./upload_overlay_controller"
application.register("upload-overlay", UploadOverlayController)

import MediaModalController from "./media_modal_controller"
application.register("media-modal", MediaModalController)

import FaceDeleteController from "./face_delete_controller"
application.register("face-delete", FaceDeleteController)

import ImageUpscalingCostCalculatorController from "./image_upscaling_cost_calculator_controller"
application.register("image-upscaling-cost-calculator", ImageUpscalingCostCalculatorController)

import ImageInpaintingCostCalculatorController from "./image_inpainting_cost_calculator_controller"
application.register("image-inpainting-cost-calculator", ImageInpaintingCostCalculatorController)

import ImageGenerationCostCalculatorController from "./image_generation_cost_calculator_controller"
application.register("image-generation-cost-calculator", ImageGenerationCostCalculatorController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import GenerationOverlayController from "./generation_overlay_controller"
application.register("generation-overlay", GenerationOverlayController)

import MigrationFormController from "./migration_form_controller"
application.register("migration-form", MigrationFormController)

import TrainingDatasetController from "./training_dataset_controller"
application.register("training-dataset", TrainingDatasetController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ImageGenerationFormController from "./image_generation_form_controller"
application.register("image-generation-form", ImageGenerationFormController)

import LoadingCounterController from "./loading_counter_controller"
application.register("loading-counter", LoadingCounterController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import TrainingDatasetCostCalculatorController from "./training_dataset_cost_calculator_controller"
application.register("training-dataset-cost-calculator", TrainingDatasetCostCalculatorController)

import GenerationTypeController from "./generation_type_controller"
application.register("generation-type", GenerationTypeController)

import TemplateSelectorController from "./template_selector_controller"
application.register("prompt-template-selector", TemplateSelectorController)

import CoverDropzoneController from "./cover_dropzone_controller"
application.register("cover-dropzone", CoverDropzoneController)

import TemplateLoadingController from "./template_loading_controller"
application.register("template-loading", TemplateLoadingController)

import TemplateCardLoaderController from "./template_card_loader_controller"
application.register("template-card-loader", TemplateCardLoaderController)

import ImageDownloadController from "./image_download_controller"
application.register("image-download", ImageDownloadController)

import NotificationDropdownController from "./notification_dropdown_controller"
application.register("notification-dropdown", NotificationDropdownController)

import UpscaleDropzoneController from "./upscale_dropzone_controller"
application.register("upscale-dropzone", UpscaleDropzoneController)

import VideoGenerationController from "./video_generation_controller"
application.register("video-generation", VideoGenerationController)

import VideoGenerationCostCalculatorController from "./video_generation_cost_calculator_controller"
application.register("video-generation-cost-calculator", VideoGenerationCostCalculatorController)

import VideoGenerationFormController from "./video_generation_form_controller"
application.register("video-generation-form", VideoGenerationFormController)

import FavoriteButtonController from "./favorite_button_controller"
application.register("favorite-button", FavoriteButtonController)

import PonyStyleController from "./pony_style_controller"
application.register("pony-style", PonyStyleController)
import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)
